/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import {
  CustomTextField,
  ModalButton,
  BigModal,
  SelectDropdown,
} from '../index';
import { Typography, Grid, MenuItem } from '@mui/material';
// import { useState, useEffect} from "react";

export const AddProjModal = (props) => {
  return (
    <>
      <BigModal
        open={props.open}
        onClose={props.onClose}
        style={{ width: '65%', p: 0, overflow: 'hidden' }}
      >
        <Grid container>
          <Grid
            item
            xs={12}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              flexDirection: 'column',
            }}
          >
            <Typography
              sx={{
                lineHeight: '1',
                fontWeight: 500,
                fontSize: '20px',
              }}
              margin={0}
              variant="subtitle1"
              align="center"
            >
              Add Details
            </Typography>
            <CustomTextField
              onChange={props.projNameOnChange}
              required={true}
              label="Project Name"
            />
            <CustomTextField
              onChange={props.projDescOnChange}
              required={true}
              multiline={true}
              label="Project Description"
            />
            <CustomTextField
              onChange={props.projHoursWorkedOnChange}
              required={true}
              type={'number'}
              label="Hours Worked"
            />
            <SelectDropdown
              fullWidth={true}
              require={true}
              margin="normal"
              onChange={props.projStatusOnChange}
              value={props.projStatus}
              label="Project Status"
            >
              <MenuItem value={true}>Active</MenuItem>
              <MenuItem value={false}>Inactive</MenuItem>
            </SelectDropdown>
            <ModalButton
              primaryBtnName="Save"
              secondaryBtnName="Cancel"
              primaryClickHandler={props.primaryClickHandler}
              secondaryClickHandler={props.secondaryClickHandler}
            />
          </Grid>
        </Grid>
      </BigModal>
    </>
  );
};
